import React from 'react';
import { Accordion, Heading, Paragraph } from '@zillow/constellation';
import ExternalLink from '../../../components/ExternalLink/ExternalLink';

export default function FAQ() {
  return (
    <Accordion>
      <Accordion.Item>
        <Accordion.Header>
          <Heading level="6">How does online tenant screening work?</Heading>
        </Accordion.Header>
        <Accordion.Panel>
          <Paragraph>
            {`All applicants fill out an online rental application with information about their current household makeup, prior residences, contact information and income. We then pull their tenant credit report history through a third-party provider known as Experian`}
            &trade;
            {` and run a tenant background check using CIC. Once everything is complete, we will compile everything into a rental application summary for you to review within your `}
            <ExternalLink href="/rental-manager">{`Zillow Rental Manager account`}</ExternalLink>
            {`.`}
          </Paragraph>
        </Accordion.Panel>
      </Accordion.Item>
      <Accordion.Item>
        <Accordion.Header>
          <Heading level="6">How do I start screening tenants online?</Heading>
        </Accordion.Header>
        <Accordion.Panel>
          <Paragraph>
            {`First, create an account to start screening tenants with `}
            <ExternalLink href="/rental-manager">{`Zillow Rental Manager`}</ExternalLink>
            {`. `}
            {`You'll need to include a property contact and the address you're renting. Once you've entered this, you can send a link to the application to potential tenants, you'll just need their email address.`}
            <br />
            {`When a renter completes an application, we'll send you an email notification. All completed applications, which includes a detailed tenant screening report, will be accessible from the "View Applications" link from this page. You only need to send one application per group of renters. The primary applicant can add any co-applicants.`}
          </Paragraph>
        </Accordion.Panel>
      </Accordion.Item>
      <Accordion.Item>
        <Accordion.Header>
          <Heading level="6">How much does it cost to screen a tenant?</Heading>
        </Accordion.Header>
        <Accordion.Panel>
          <Paragraph>
            {`Tenant screening reports are free for property managers. Renters pay a $35 tenant screening and application fee, which allows them to apply to your listing and an unlimited number of participating rentals for 30 days.`}
          </Paragraph>
        </Accordion.Panel>
      </Accordion.Item>
      <Accordion.Item>
        <Accordion.Header>
          <Heading level="6">How long do tenant credit and background checks take?</Heading>
        </Accordion.Header>
        <Accordion.Panel>
          <Paragraph>
            {`Most tenant credit and background checks will be returned within minutes of the renter sending the application. On rare occasions, tenant background check requests require a manual review that can take up to 24 hours. We will let you know if a manual review is required.`}
          </Paragraph>
        </Accordion.Panel>
      </Accordion.Item>
      <Accordion.Item>
        <Accordion.Header>
          <Heading level="6">What does a tenant background and credit check show?</Heading>
        </Accordion.Header>
        <Accordion.Panel>
          <Paragraph>
            {`A tenant background check typically includes a national criminal search, sex offender search and eviction history. You can view a sample of our CIC tenant background check `}
            <ExternalLink href="https://files.zillowrentals.com/rental-applications/sample_background_report.pdf">
              {`here`}
            </ExternalLink>
            {`.`}
            <br />
            {`A tenant credit check typically includes a credit score alongside a comprehensive overview of the applicant's credit history. You can view a sample of our Experian`}
            &trade;
            {` credit report `}
            <ExternalLink href="https://files.zillowrentals.com/rental-applications/sample_credit_report.pdf">
              {`here`}
            </ExternalLink>
            {`. `}
            {`In some cases, credit and background checks are modified to comply with state and local `}
            <ExternalLink href="https://www.zillow.com/z/rental-manager/limits-rental-applications-reports/">
              {`legal requirements`}
            </ExternalLink>
            {`.`}
          </Paragraph>
        </Accordion.Panel>
      </Accordion.Item>
    </Accordion>
  );
}
